<template>
	<div class="flex flex-col gap-8px">
		<BaseOTP
			:length="length"
			:value="modelValue"
			@input="updateValue"
			:isError="isError"
			:disabled="disabled"
		/>
		<BaseMessageDisplay
			:isError="isError"
			:errorMessage="errorMessage"
			:disabled="disabled"
		/>
	</div>
</template>

<script setup lang="ts">
import BaseMessageDisplay from '@/components/ui/input/BaseMessageDisplay.vue'
import BaseOTP from '@/components/ui/input/BaseOTP.vue'

const props = defineProps({
	modelValue: {
		type: String,
		required: true,
	},
	length: {
		type: Number,
		default: 6,
	},
	isError: {
		type: Boolean,
		default: false,
	},
	errorMessage: {
		type: String,
		default: '',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (newValue: string) => {
	emit('update:modelValue', newValue)
}
</script>
